import { useState, useEffect } from 'preact/hooks';
import { html, Modal, Field, closeModal, notify } from './common.js';
import { get, post } from '../api.js';

export function Login({ onDone }) {
  const [email, setEmail] = useState(''), [pw, setPw] = useState(''), [err, setErr] = useState(null), [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(null);
    try { await post('/api/auth/login', { email, password: pw }); onDone(); } catch (x) { setErr(x.message); } finally { setBusy(false); }
  };
  return html`<div class="login"><form class="card" onSubmit=${submit}>
    <div class="brand" style="margin-bottom:14px"><div class="logo">B</div><span>Cave Atlas</span></div>
    <h1>Members sign in</h1><p class="muted small">Cave locations and records here are for members only.</p>
    <${Field} label="Email"><input type="email" autocomplete="username" value=${email} onInput=${(e) => setEmail(e.target.value)} required /><//>
    <${Field} label="Password"><input type="password" autocomplete="current-password" value=${pw} onInput=${(e) => setPw(e.target.value)} required /><//>
    ${err && html`<div class="err">${err}</div>`}
    <button class="btn primary" style="width:100%;justify-content:center;margin-top:8px" disabled=${busy}>${busy ? 'Signing in…' : 'Sign in'}</button>
    <p class="tiny muted" style="margin-top:12px">Forgot your password? Ask an admin for a reset link.</p>
  </form></div>`;
}

export function Invite({ token, onDone }) {
  const [info, setInfo] = useState(null), [err, setErr] = useState(null), [pw, setPw] = useState(''), [pw2, setPw2] = useState('');
  useEffect(() => { get(`/api/invite/${token}`).then(setInfo).catch(e => setErr(e.message)); }, []);
  const submit = async (e) => {
    e.preventDefault(); setErr(null);
    if (pw !== pw2) { setErr('Passwords do not match'); return; }
    try { await post(`/api/invite/${token}`, { password: pw }); history.replaceState(null, '', '/'); onDone(); } catch (x) { setErr(x.message); }
  };
  return html`<div class="login"><form class="card" onSubmit=${submit}>
    <h1>Set your password</h1>
    ${info ? html`<p class="muted small">${info.name} · ${info.email}</p>
      <${Field} label="New password (10+ characters)"><input type="password" autocomplete="new-password" value=${pw} onInput=${(e) => setPw(e.target.value)} minlength="10" required /><//>
      <${Field} label="Repeat"><input type="password" autocomplete="new-password" value=${pw2} onInput=${(e) => setPw2(e.target.value)} required /><//>
      <button class="btn primary" style="width:100%;justify-content:center;margin-top:8px">Save and sign in</button>` : !err && html`<p class="muted">Checking link…</p>`}
    ${err && html`<div class="err">${err}</div>`}
  </form></div>`;
}

export function PasswordModal() {
  const [cur, setCur] = useState(''), [pw, setPw] = useState(''), [err, setErr] = useState(null);
  const save = async () => {
    try { await post('/api/me/password', { current: cur, new: pw }); closeModal(); notify('Password changed'); } catch (e) { setErr(e.message); }
  };
  return html`<${Modal} title="Change password" footer=${html`${err && html`<span class="err">${err}</span>`}<button class="btn" onClick=${closeModal}>Cancel</button>
    <button class="btn primary" disabled=${pw.length < 10} onClick=${save}>Save</button>`}>
    <${Field} label="Current password"><input type="password" value=${cur} onInput=${(e) => setCur(e.target.value)} /><//>
    <${Field} label="New password (10+ characters)"><input type="password" value=${pw} onInput=${(e) => setPw(e.target.value)} /><//>
  <//>`;
}
